export const FEED_TABS = ["stream", "cards", "daily-question"] as const
export type FeedTab = (typeof FEED_TABS)[number]
